import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { map, switchMap } from 'rxjs';
import { AuthStore } from '../stores/auth.store';

/**
 * Enroll and reset-password must stay reachable while a session exists
 * (e.g. shared machine, admin testing). Clears server cookies and local auth
 * state before the page loads, without redirecting away.
 */
const ensurePublicAuthFlow = () => {
  const auth = inject(AuthStore);

  return auth.waitUntilSessionReady().pipe(
    switchMap(() => auth.signOutForCredentialSetup()),
    map(() => true),
  );
};

export const publicAuthFlowGuard: CanActivateFn = () => ensurePublicAuthFlow();

export const publicAuthFlowChildGuard: CanActivateChildFn = () => ensurePublicAuthFlow();
